import { createSelector } from 'reselect'

import { featureRootSelector } from '../selectors'

const trialExtensionSelector = createSelector(
  featureRootSelector,
  ({ trialExtension }) => trialExtension
)

export const trialExtensionLoadingSelector = createSelector(
  trialExtensionSelector,
  ({ trialExtensionLoading }) => !!trialExtensionLoading
)

export const extendedDaysSelector = createSelector(
  trialExtensionSelector,
  ({ extendedDays }) => extendedDays
)

export const isErrorStateSelector = createSelector(
  trialExtensionSelector,
  ({ success }) => success === false
)

export const isSuccessStateSelector = createSelector(
  trialExtensionSelector,
  ({ success }) => success === true
)

export const eligibilityCheckLoadingSelector = createSelector(
  trialExtensionSelector,
  ({ eligibilityCheckLoading }) => !!eligibilityCheckLoading
)

export const eligibleForExtensionSelector = createSelector(
  trialExtensionSelector,
  ({ eligibleForExtension }) => eligibleForExtension
)
